const colors = {
  green: {
    400: "#01DB00",
    700: "#009900",
    900: "#005D00",
  },
  blue: {
    200: "#E6F2F9",
    300: "#77D1FE",
    400: "#007EE7",
  },
  white: {
    400: "#ffffff",
  },
  grey: {
    300: "#AEAEAE",
    400: "#202020",
    900: "#000000",
  },
}

export default colors
